import { bunchGetAllOptions } from "@/api/bunch";

const state = {
    bunchFilter: null,
    bunchOptions: null,
};

const mutations = {
    APPLY_BUNCH_FILTER: (state, data) => {
        state.bunchFilter = data;
    },
    GET_ALL_OPTIONS: (state, data) => {
        state.bunchOptions = data;
    },
};

const actions = {
    async applyBunchFilter({ commit }, data) {
        commit("APPLY_BUNCH_FILTER", data); 
    },

    async getAllBunchOptions({ commit }, data) {
        let res = await bunchGetAllOptions({
            ...data, 
        });
        if (res) {
            commit("GET_ALL_OPTIONS", res); 
        }
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions
};




// WEBPACK FOOTER //
// ./src/vuex/modules/bunch.js